import { Grid } from '@postenbring/hedwig-react';
import { OperationReport } from '../../components/OperationReport';

export const OperationReports = ({ messages, textWhenNoOperationReports, language, errorMessage }) => (
    <Grid gapY="48-64" span={{ initial: 12, large: 9 }}>
        {messages.map(({heading, publishDate, utext}) => (
            <OperationReport heading={heading} publishDate={publishDate} language={language} utext={utext} key={heading + publishDate} />
        ))}
        {messages.length === 0 && !errorMessage && <div>{textWhenNoOperationReports}</div>}
        {errorMessage && <div>{errorMessage}</div>}
    </Grid>
)
